import * as React from 'react';

import type { Cookies } from 'bundles/page/types';

export default React.createContext<Cookies>({});
